import Cookie from 'js-cookie'
export default class CookiesLogic {
  static instance = null
  _list = [
    {
      key: 'sistemski',
      label: 'Sistemski piškotki (vedno podeljeni)',
      value: true,
      required: true,
      description: 'So ključni in brez njih stran ne bo delovala, kot bi morala. Nastavijo se, ob prijavi ali s ' +
        'kakršnokoli interakcijo s spletno stranjo. Za te piškotke vaša privolitev ni potrebna.',
      items: [
        {
          name: 'piskotek',
          domain: 't-2',
          description: 'Nujni piškotek, ki si zapomni vašo izbiro nastavitev za nalaganje piškotkov na naši ' +
            'spletni strani. ',
          expiresIn: '4 leta'
        },
        {
          name: 'access_token',
          domain: 't-2',
          description: 'Nujni piškotek na naši spletni strani ki anonimizirano ločuje uporabnike enega od drugega in ' +
            's tem omogoča prijavo v in uporabo različnih storitev.',
          expiresIn: '1h'
        },
        {
          name: 'access_token_expires_at',
          domain: 't-2',
          description: 'Nujni piškotek, ki hrani informacijo o poteku avtorizacijskega žetona in nam omogoče ' +
            'podaljšanje le tega',
          expiresIn: '1h'
        }
      ]
    },
    {
      key: 'analitika',
      label: 'Piškotki spletne analitike',
      value: false,
      required: false,
      description: 'Z njimi analiziramo promet na naši strani. Beležimo obisk, oglede strani, trajanje obiska ipd. ' +
        'Vse s ciljem, da lahko izboljšamo tudi vašo uporabniško izkušnjo.',
      items: [
        {
          name: '_ga',
          domain: 'google',
          description: 'Piškotek, ki med seboj razlikuje uporabnike na spletni strani.',
          expiresIn: '2 leti'
        },
        {
          name: '_ga_12345678901234567890',
          domain: 'google',
          description: 'Piškotek se uporablja za ohranjanje stanja seje',
          expiresIn: '2 leti'
        }
      ]
    }
  ]
  static getInstance () {
    if (this.instance === null) {
      this.instance = new this()
      this.instance.parseListFromCookies()
    }
    return this.instance
  }

  parseListFromCookies () {
    let cookiesFromCookies = Cookie.get('piskotki')
    if (cookiesFromCookies !== undefined) {
      cookiesFromCookies = JSON.parse(cookiesFromCookies)
      if (typeof cookiesFromCookies === 'object') {
        this._list.forEach((listItem) => {
          if (cookiesFromCookies[listItem.key] !== undefined) {
            listItem.value = cookiesFromCookies[listItem.key]
          }
        })
      }
    }
  }

  izberiVse (shrani = false) {
    this._list.forEach((item) => {
      item.value = true
    })
    if (shrani) {
      this.shraniPiskotke()
    }
  }

  izberiObvezne (samoObvezne = false, shrani = false) {
    this._list.forEach((item) => {
      if (item.required) {
        item.value = true
      } else {
        if (samoObvezne === true) {
          item.value = false
        }
      }
    })
    if (shrani) {
      this.shraniPiskotke()
    }
  }

  shraniPiskotke () {
    let cookies = {}
    this._list.forEach((item) => {
      cookies[item.key] = item.value
      if (item.key === 'analitika') {
        if (item.value === false) {
          this.izbrisAnalitike()
        }
      }
    })
    Cookie.set('piskotki', JSON.stringify(cookies), {expires: 4 * 365})
  }

  izbrisAnalitike () {
    this._list.forEach((sklop) => {
      if (sklop.key === 'analitika') {
        sklop.items.forEach((item) => {
          Cookie.remove(item.name, {path: '/', domain: '.server.test'})
        })
      }
    })
  }

  get list () {
    return this._list
  }

  set list (value) {
    this._list = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/CookiesLogic.js